<template>
  <div
    id="connectorScreen"
    class="page"
  >
    <loan-calculator-header />
    <content-spinner :show="loading" />
    <div
      v-if="!loading"
      id="pageContent"
      class="page-content p-4"
    >
      <calculators-list />
      <folders-list />
    </div>

    <AddEditCalculatorModal @update="onUpdate" />
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import AddEditCalculatorModal from './components/AddEditCalculatorModal';
import ContentSpinner from '../../core/components/ContentSpinner';
import CalculatorCard from './components/CalculatorCard';
import NoContent from '../../core/components/NoContent.vue';
import ModuleCard from '../DataManagement/views/module/components/ModuleCard.vue';
import TableCard from '../DataManagement/components/TableCard.vue';
import moduleViewMixin from '../../core/mixins/module-view.mixin';
import CalculatorsList from '@/modules/LoanCalculator/components/CalculatorsList.vue';
import FoldersList from '@/modules/DataManagement/views/module/components/FoldersList.vue';
import LoanCalculatorHeader from '@/modules/LoanCalculator/components/LoanCalculatorHeader.vue';

const {mapActions, mapState} = createNamespacedHelpers('loanCalculator');
const {
  mapState: sidebarMapState,
  mapActions: sidebarMapActions,
} = createNamespacedHelpers('sidebar');

const {
  mapState: mapStateDataManagement,
  mapActions: mapActionsDataManagement,
} = createNamespacedHelpers('dataManagement');


export default {
  name: 'LoanCalculator',
  components: {
    LoanCalculatorHeader,
    FoldersList,
    CalculatorsList,
    TableCard,
    ModuleCard,
    NoContent,
    CalculatorCard,
    AddEditCalculatorModal,
    ContentSpinner,
  },
  mixins: [moduleViewMixin],
  data() {
    return {
      loading: false,
      moduleUuid: '37f9e5ae-a0ab-425f-a8ea-b40f5eb79f7f',// this can be hardcoded, as it is system module, and created by ATLAS by script with fixed guid - if this is changed check BacMDM -> DTO -> System Modules
      folderData: [],
    };
  },
  computed: {
    ...mapStateDataManagement({
      folders: state => state.folders,
      // moduleData: state => state.moduleData,
      // permissionTypes: state => state.permissionTypes,
      // permissionItemTypes: state => state.permissionItemTypes,
    }),
    ...sidebarMapState({
      isLoading: state => state.isLoading,
    }),
    // ...mapState({
    //   calculators: state => state.data,
    // }),
    // ...sidebarMapState({
    //   moduleInfo: state => state.moduleInfo
    // }),
    // foldersData() {
    //   return this.folderData
    //       .filter(f => ![
    //         this.permissionTypes.none,
    //         this.permissionTypes.deny
    //       ].includes(f.currentUserPermissionLevel))
    //       .map(f => ({...f, showNoContent: ('tables' in f)}))
    // },
  },
  methods: {
    ...mapActions([
      'showAddEditModal',
      'deleteCalculator',
      'calculate',
      'getAllCalculator',
    ]),
    ...mapActionsDataManagement(['getFolders', 'getModuleData']),
    ...sidebarMapActions(['getModuleDetails']),
    async getData() {
      await this.getAllCalculator();
    },
    async prepareData() {
      await this.getFolders(this.moduleUuid);
      this.folderData = [...this.folders.data];
    },
    async loadData() {
      this.loading = true;
      await this.getData();
      await this.getModuleData(this.moduleUuid);
      await this.getModuleDetails(this.moduleUuid);//this is setting folders and sorting
      this.loading = false;
      await this.prepareData();
    },
    onUpdate() {
      this.loadData();
    },
  },
  async  mounted() {
    await this.loadData();
  },
};
</script>

<style lang="scss" scoped>

</style>
